import Address from "./address";
import KeyValue from "./keyValue";

export default interface Site {
    id: number;
    name?: string;
    siteNumber?: string;
    contactName?: string;
    contactPhone?: string;
    contactEmail?: string;
    siteManager?: KeyValue;
    siteType?: KeyValue;
    address?: Address;
    attachments?:KeyValue[]
}

export const initialSite: Site = {
    id: 0,
    name: "",
    siteNumber: "",
    siteManager: undefined,
    siteType: undefined,
    address: {
      id: 0,
      line1: "",
      line2: "",
      city: "",
      usaState: undefined,
      zipCode: "",
    },
    contactName: "",
    contactEmail: "",
    contactPhone: ""
}